import roles from "../../api/roles";

export default {
  namespaced: true,
  state: {
    items: [],
  },
  mutations: {
    setItems(state, items) {
      state.items = items;
    },
  },
  actions: {
    fetchAll({ commit }, data) {
      return roles.get(data).then((response) => {
        commit("setItems", response.data);
        return response;
      });
    },
  },
};
